import { createSlice } from "@reduxjs/toolkit";

export const messageSlice = createSlice({
  name: "message",
  initialState: [],
  reducers: {
    setMessages: (state, action) => {
      state.splice(0, state.length);
      const messages = [...action.payload];
      for (let i = 0; i < messages.length; i++) state.push(messages[i]);
    },
    // Ignores a message already on screen.
    //
    // Two things add the same one. The sender's own browser adds it when the
    // post comes back, and the socket then broadcasts it to everyone on the
    // task including the sender, who adds it again. One row in the database,
    // two bubbles on screen, and it showed up on every message the server
    // generates: "I estimated the task" appeared twice to whoever estimated.
    //
    // Guarding here rather than at each call site, because there are four of
    // them and the next one will not remember.
    addMessage: (state, action) => {
      const arriving = action.payload;
      // A message with no id cannot be compared, and one is better than none.
      if (
        arriving?._id &&
        state.some((m) => String(m?._id) === String(arriving._id))
      )
        return;
      state.push(arriving);
    },
    deleteMessage: (state, action) => {
      const messageId = action.payload;
      for (let i = 0; i < state.length; i++) {
        if (state[i]._id == messageId) state[i].message_deleted = true;
      }
    },
    deleteAllMessages: (state) => {
      state.splice(0, state.length);
    },
    translateMessage: (state, action) => {
      const { messageId, message } = action.payload;
      for (let i = 0; i < state.length; i++) {
        if (state[i]._id == messageId) state[i].message = message;
      }
    },
    updateMessage: (state, action) => {
      const { _id, message, images, files, task, sender } = action.payload;
      for (let i = 0; i < state.length; i++) {
        if (
          state[i]._id == null &&
          state[i].message == message &&
          state[i].images.length == images.length &&
          state[i].files.length == files.length &&
          state[i].task == task._id &&
          task._id == state[i].task &&
          sender._id == state[i].sender._id
        ) {
          state[i]._id = _id;
          break;
        }
      }
    },
    updateEditMessage: (state, action) => {
      const { id, message } = action.payload;
      for (let i = 0; i < state.length; i++) {
        if (state[i]._id == id) {
          state[i].message = message;
          state[i].edited = true;
          break;
        }
      }
    },
  },
});

export const {
  setMessages,
  addMessage,
  deleteMessage,
  deleteAllMessages,
  translateMessage,
  updateMessage,
  updateEditMessage,
} = messageSlice.actions;

export default messageSlice.reducer;
